export default "__VITE_ASSET__DHA5Wzm3__"